module.exports = __webpack_public_path__ + "img/wsb-howtoplay-images-02.afafa5b7.jpg";